import { Headers as Headers$1 } from 'whatwg-fetch';
import querystring from 'querystring';
import uuid from 'uuid';
import { Logger } from '@cvent/nucleus-logging';

if (!global.Headers && Headers$1) {
  global.Headers = Headers$1;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var httpLogPageLoadId = uuid.v4();

var HTTP_REQUEST_ID = 'HttpLogRequestId';
var HTTP_PAGE_ID = 'HttpLogPageLoadId';
/**
 * Immutable builder class for fetch api Request objects.
 * every time a param is set via the builder a new instance of the builder is created.
 * builds to: https://developer.mozilla.org/en-US/docs/Web/API/Request/Request
 */

var RequestBuilder = /*#__PURE__*/function () {
  function RequestBuilder() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var url = _ref.url,
        requestOptions = _objectWithoutProperties(_ref, ["url"]);

    _classCallCheck(this, RequestBuilder);

    var headers = requestOptions.headers ? new Headers(requestOptions.headers) : new Headers();
    this.requestOptions = _objectSpread2(_objectSpread2({
      queries: {}
    }, requestOptions), {}, {
      headers: headers
    });

    if (url) {
      var _url$split = url.split('?'),
          _url$split2 = _slicedToArray(_url$split, 2),
          baseUrl = _url$split2[0],
          search = _url$split2[1];

      this.requestOptions.baseUrl = baseUrl;

      if (search) {
        this.requestOptions.queries = querystring.parse(search);
      }
    }
  }

  _createClass(RequestBuilder, [{
    key: "cloneWithOverrides",
    value: function cloneWithOverrides(overrides) {
      return new RequestBuilder(_objectSpread2(_objectSpread2({}, this.requestOptions), overrides));
    }
    /* sets credentials to allow */

  }, {
    key: "withCookies",
    value: function withCookies() {
      // we're doing everything via CORS now so there is no use case for 'same-origin'
      return this.cloneWithOverrides({
        credentials: 'include'
      });
    }
  }, {
    key: "withNoCache",
    value: function withNoCache() {
      // in order to avoid caching, passing `no-cache` avoids calls from being cached in the browser
      return this.cloneWithOverrides({
        cache: 'no-cache'
      });
    }
    /* Return a builder with a url set to url */

  }, {
    key: "url",
    value: function url(_url) {
      return this.cloneWithOverrides({
        url: _url
      });
    }
    /* Return a builder with the HTTP method for request set to HEAD */

  }, {
    key: "head",
    value: function head() {
      return this.method('HEAD');
    }
    /* Return a builder with the HTTP method for request set to PATCH */

  }, {
    key: "patch",
    value: function patch() {
      return this.method('PATCH');
    }
    /* Return a builder with the HTTP method for request set to POST */

  }, {
    key: "post",
    value: function post() {
      return this.method('POST');
    }
    /* Return a builder with the HTTP method for request set to GET */

  }, {
    key: "get",
    value: function get() {
      return this.method('GET');
    }
    /* Return a builder with the HTTP method for request set to PUT */

  }, {
    key: "put",
    value: function put() {
      return this.method('PUT');
    }
    /* Return a builder with the HTTP method for request set to DELETE */

  }, {
    key: "delete",
    value: function _delete() {
      return this.method('DELETE');
    }
    /* Return a builder with the HTTP method for request set to OPTIONS */

  }, {
    key: "options",
    value: function options() {
      return this.method('OPTIONS');
    }
    /* Return a builder with the HTTP method for request built by the builder. */

  }, {
    key: "method",
    value: function method(_method) {
      return this.cloneWithOverrides({
        method: _method
      });
    }
    /** Return a builder with the auth token set the Autorization header **/

  }, {
    key: "auth",
    value: function auth(token) {
      return this.header('Authorization', token);
    }
    /** Return a builder with the csrf token set the X-Cvent-CSRF header **/

  }, {
    key: "csrf",
    value: function csrf(csrfToken) {
      return this.header('X-Cvent-CSRF', csrfToken);
    }
    /**
     * Returns a builder with one or more path components added to the url.
     * leading and trailing slashes will be stripped from each path component.
     */

  }, {
    key: "addPath",
    value: function addPath() {
      for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
        paths[_key] = arguments[_key];
      }

      var strippedPathComponents = paths.map(function (s) {
        return s.replace(/^\/|\/$/g, '');
      });
      var baseUrlWithoutSlash = this.requestOptions.baseUrl.replace(/\/$/, '');
      return this.cloneWithOverrides({
        baseUrl: [baseUrlWithoutSlash].concat(_toConsumableArray(strippedPathComponents)).join('/')
      });
    }
    /**
     * Return a builder with the query param. If the param value is an array the
     * param will appear for each value in the array.
     */

  }, {
    key: "query",
    value: function query(param, value) {
      return this.queries(_defineProperty({}, param, value));
    }
    /**
     * Return a builder with the query params in the passed object. If a param value is an array the
     * param will appear for each value in the array.
     */

  }, {
    key: "queries",
    value: function queries(_queries) {
      return this.cloneWithOverrides({
        queries: _objectSpread2(_objectSpread2({}, this.requestOptions.queries), _queries)
      });
    }
    /* Return a builder with the json string of value set as the request body */

  }, {
    key: "json",
    value: function json(value) {
      var body = JSON.stringify(value);
      return this.header('Content-Type', 'application/json').body(body);
    }
    /* Return a builder with a set request body */

  }, {
    key: "body",
    value: function body(value) {
      return this.cloneWithOverrides({
        body: value
      });
    }
    /* Return a builder with a header upserted to the specified value. Plural headers are not supported */

  }, {
    key: "header",
    value: function header(_header, value) {
      return this.headers(_defineProperty({}, _header, value));
    }
    /* Return a builder with headers upserted to the specified values. Plural headers are not supported */

  }, {
    key: "headers",
    value: function headers(_headers) {
      var newHeaders = new Headers(this.requestOptions.headers);

      for (var headerName in _headers) {
        if (_headers.hasOwnProperty(headerName)) {
          newHeaders.set(headerName, _headers[headerName]);
        }
      }

      return this.cloneWithOverrides({
        headers: newHeaders
      });
    }
    /* Build a fetch Request object */
    // https://developer.mozilla.org/en-US/docs/Web/API/Request

  }, {
    key: "build",
    value: function build() {
      var headers = new Headers(this.requestOptions.headers);

      if (!headers.has(HTTP_REQUEST_ID)) {
        headers.set(HTTP_REQUEST_ID, uuid.v4());
      }

      if (!headers.has(HTTP_PAGE_ID)) {
        // allow user code to provide their own pageload id if they want.
        headers.set(HTTP_PAGE_ID, httpLogPageLoadId);
      }

      var url = this.requestOptions.baseUrl;

      if (!url) {
        throw new Error('RequestBuilder: url not set');
      }

      if (Object.keys(this.requestOptions.queries).length > 0) {
        url += '?' + querystring.stringify(this.requestOptions.queries);
      }

      return new Request(url, _objectSpread2(_objectSpread2({}, this.requestOptions), {}, {
        headers: headers
      }));
    }
  }]);

  return RequestBuilder;
}();

/**
 * Calculate the delay considering the maximum delay and the option to introduce random jitter
 *
 * This implementation is "full jitter" strategy that always computes a new random delay between 0 and the computed exponential backoff
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
 *
 * @param backoffDelay - maximum amount of time in ms for the backoff delay
 * @param jitter - whether to randomly select a delay between 0 and the maxDelay
 **/
function delayStrategy(backoffDelay, jitter) {
  var delay = jitter ? Math.random() * backoffDelay : backoffDelay;

  if (delay < 0) {
    delay = 0;
  }

  return delay;
}

var RETRYABLE_STATUS_CODES = [429, 502, 503, 504];

var DEFAULT_OPTIONS = {
  initialDelay: 500,
  multiplicationFactor: 2,
  maxDelay: 2000,
  retryStatuses: RETRYABLE_STATUS_CODES,
  maxRetries: undefined,
  requestTimeoutMillis: 0,
  jitter: true
};
var LOG = new Logger('fetchAndRetryIfServerBusy');

var pause = function pause(milliseconds) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve();
    }, milliseconds);
  });
};

var maxRetriesSpecifiedOrNot = function maxRetriesSpecifiedOrNot(maxRetries) {
  // If maxRetries has been specified, then we use it and ignore maxDelay.
  // Note maxRetries = 0 supported hence more involved type checking....
  return typeof maxRetries !== 'undefined' && maxRetries !== null;
};

var getTimeout = function getTimeout(abortController, requestTimeoutMillis) {
  return setTimeout(function () {
    abortController.abort();
  }, requestTimeoutMillis);
};
/**
 * Set the default options used in the absence of options provided to fetchAndRetryIfServerBusy.
 * This method is intended for use by an application in order to setup global defaults without
 * needing to update every fetchAndRetryIfServerBusy call.
 * @param options - The default options.
 */


function setGlobalDefaultFetchAndRetryIfServerBusyOptions(options) {
  Object.assign(DEFAULT_OPTIONS, options);
}
/**
 * Wrapper for the fetch api that takes additional options around how to deal with
 * server too busy conditions.  Note - options can be set when calling fetchAndRetryIfServerBusy
 * or globally (defaults) via setGlobalDefaultFetchAndRetryIfServerBusyOptions().  Options provided via call will override any
 * defaults.
 * @param request - The fetch request created from the RequestBuilder.
 * @param options.initialDelay - number of milliseconds to wait if the 1st call is a retry status
 * @param options.multiplicationFactor - exponential back off
 * @param options.maxDelay - [Deprecated] use maxRetries instead.
 * @param options.maxRetries - number of retry attempts, no default, if set then maxDelay will be ignored.
 * @param options.retryStatuses - response statuses to retry, defaults to [429]
 * @param options.jitter - whether to add random jitter to the retry backoff delay, defaults to true
 * @param options.requestTimeoutMillis - timeout associated with each request, defaults to 0 (disabled).
 **/

function fetchAndRetryIfServerBusy(request) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$initialDelay = options.initialDelay,
      initialDelay = _options$initialDelay === void 0 ? DEFAULT_OPTIONS.initialDelay : _options$initialDelay,
      multiplactionFactor = options.multiplactionFactor,
      multiplicationFactor = options.multiplicationFactor,
      _options$maxDelay = options.maxDelay,
      maxDelay = _options$maxDelay === void 0 ? DEFAULT_OPTIONS.maxDelay : _options$maxDelay,
      _options$retryStatuse = options.retryStatuses,
      retryStatuses = _options$retryStatuse === void 0 ? DEFAULT_OPTIONS.retryStatuses : _options$retryStatuse,
      _options$maxRetries = options.maxRetries,
      maxRetries = _options$maxRetries === void 0 ? DEFAULT_OPTIONS.maxRetries : _options$maxRetries,
      _options$requestTimeo = options.requestTimeoutMillis,
      requestTimeoutMillis = _options$requestTimeo === void 0 ? DEFAULT_OPTIONS.requestTimeoutMillis : _options$requestTimeo,
      _options$jitter = options.jitter,
      jitter = _options$jitter === void 0 ? DEFAULT_OPTIONS.jitter : _options$jitter;
  var exponentialBackoffFactor = multiplicationFactor || multiplactionFactor || DEFAULT_OPTIONS.multiplicationFactor;
  var useMaxRetries = maxRetriesSpecifiedOrNot(maxRetries);
  var delay = initialDelay;
  var attempt = 0;

  function checkAndFetch() {
    function prepareRequest() {
      // Request objects cannot be reused (https://stackoverflow.com/questions/55979921/error-request-object-that-has-already-been-used)
      var requestClone;
      var timeout;

      if (requestTimeoutMillis > 0) {
        var abortController = new AbortController();
        timeout = getTimeout(abortController, requestTimeoutMillis);

        if (request.signal) {
          // Note - some frameworks e.g. apollo-client's HTTP link can set signal.
          LOG.debug("requestTimeoutMillis will override request.signal.  Did you mean to set both?: ".concat(request.method, ", ").concat(request.url));
        }

        requestClone = new Request(request, {
          signal: abortController.signal
        });
      } else {
        requestClone = new Request(request);
      }

      return [requestClone, timeout];
    }

    var _prepareRequest = prepareRequest(),
        _prepareRequest2 = _slicedToArray(_prepareRequest, 2),
        preparedRequest = _prepareRequest2[0],
        timeout = _prepareRequest2[1];

    return fetch(preparedRequest).then(function (response) {
      if (timeout) {
        clearTimeout(timeout);
      }

      var maxRetriesOrDelayExceeded = useMaxRetries ? ++attempt > maxRetries : delay > maxDelay;

      if (maxRetriesOrDelayExceeded || !retryStatuses.includes(response.status)) {
        return response;
      }

      var iterationDelay = delayStrategy(delay, jitter);
      LOG.warn("server was busy, retrying again in ".concat(iterationDelay, " MS. { url: ").concat(preparedRequest.url, ", method: ").concat(preparedRequest.method, ", attempt: ").concat(attempt, "}"));
      var newResponse = pause(iterationDelay).then(checkAndFetch);
      delay = delay * exponentialBackoffFactor;
      return newResponse;
    }).catch(function (error) {
      LOG.error("Error calling { url: ".concat(preparedRequest.url, ", method: ").concat(preparedRequest.method, "}: ").concat(error));
      throw error;
    });
  }

  return checkAndFetch().then(function (response) {
    if (retryStatuses.includes(response.status)) {
      LOG.warn("max retries reached, giving up. ".concat(delay, " MS. { url: ").concat(request.url, ", method: ").concat(request.method, "}"));
    }

    return response;
  });
}

/**
 * A custom error class to be used with fetch
 */
function FetchError(message, response) {
  var instance = new Error(message);
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  Object.defineProperty(instance, 'response', {
    value: response
  });
  return instance;
}
FetchError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
Object.setPrototypeOf(FetchError, Error);

/**
 * Error handler callback
 * @callback errorHandler
 * @param {Response} response - see https://developer.mozilla.org/en-US/docs/Web/API/Response
 */

/**
 * A custom fetch wrapper that enables additional behaviors based on the options passed in
 *
 * Sample usage:
 * <pre>
 * const fetch = fetchWithOptions({
 *   errorHandler: response => {
 *     throw new FetchError(response.statusText, response);
 *   },
 *   retry: {
 *     initialDelay: 1000,
 *     multiplicationFactor: 2,
 *     maxRetries: 3
 *     retryStatuses: [429, 502, 503, 504],
 *     jitter: true,
 *     requestTimeoutMillis: 0
 *   }
 * });
 * </pre>
 *
 * @param {Object} options
 * @param {errorHandler} options.errorHandler - function to call when the response is not successful (status code >= 300)
 *                                              defaults to throwing {@link FetchError}
 * @param {Object} options.retry - retry fetch request, use same retry options as {@link fetchAndRetryIfServerBusy}
 */

function fetchWithOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$errorHandler = _ref.errorHandler,
      errorHandler = _ref$errorHandler === void 0 ? function (response) {
    throw new FetchError(response.statusText, response);
  } : _ref$errorHandler,
      _ref$retry = _ref.retry;

  _ref$retry = _ref$retry === void 0 ? {} : _ref$retry;
  var initialDelay = _ref$retry.initialDelay,
      multiplicationFactor = _ref$retry.multiplicationFactor,
      retryStatuses = _ref$retry.retryStatuses,
      maxRetries = _ref$retry.maxRetries,
      jitter = _ref$retry.jitter,
      requestTimeoutMillis = _ref$retry.requestTimeoutMillis;
  return function (request) {
    var response = fetchAndRetryIfServerBusy(request, {
      initialDelay: initialDelay,
      multiplicationFactor: multiplicationFactor,
      maxRetries: maxRetries,
      retryStatuses: retryStatuses,
      jitter: jitter,
      requestTimeoutMillis: requestTimeoutMillis
    });
    return response.then(function (res) {
      if (!res.ok) {
        errorHandler(res);
      }

      return res;
    });
  };
}

export { FetchError, RequestBuilder, delayStrategy, fetchAndRetryIfServerBusy, fetchWithOptions, httpLogPageLoadId, setGlobalDefaultFetchAndRetryIfServerBusyOptions };
//# sourceMappingURL=index.js.map
